import { jsx as r } from "react/jsx-runtime";
import c from "../profile/icons/default-avatar-icon.mjs";
import n from "../items/link/icons/link-thumbnail-icon.mjs";
import m from "../items/optin/icons/optin-thumbnail-icon.mjs";
import u from "../items/product/icons/product-download-thumbnail-icon.mjs";
import a from "../icons/product-download-cover.mjs";
import i from "../items/product/icons/product-e-course-thumbnail-icon.mjs";
import l from "../icons/e-course-cover.mjs";
import d from "../items/product/icons/physical-product-thumbnail-icon.mjs";
import h from "../icons/physical-product-cover.mjs";
import { StoreImageEnum as t } from "../enums/store-image-enum.mjs";
const E = (e, o) => {
  switch (e) {
    case t.profile:
      return /* @__PURE__ */ r(c, { ...o });
    case t.link_thumbnail:
      return /* @__PURE__ */ r(n, { ...o });
    case t.optin_thumbnail:
      return /* @__PURE__ */ r(m, { ...o });
    case t.product_download_thumbnail:
      return /* @__PURE__ */ r(u, { ...o });
    case t.product_download_cover:
      return /* @__PURE__ */ r(a, { ...o });
    case t.e_course_thumbnail:
      return /* @__PURE__ */ r(i, { ...o });
    case t.e_course_cover:
      return /* @__PURE__ */ r(l, { ...o });
    case t.physical_product_thumbnail:
      return /* @__PURE__ */ r(d, { ...o });
    case t.physical_product_cover:
      return /* @__PURE__ */ r(h, { ...o });
  }
};
export {
  E as getStoreDefaultImage
};
